import { JamEventDetails } from "@/src/types/JamEventDetails";
import { LeaderboardMiniTeam, LeaderboardTeam } from "@/src/types/JamLeaderboard";
import { i18nKeys } from "@/src/utils/i18n.utils";
import { Box, Grid, Icon, Link } from "@amzn/awsui-components-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const BriefTeamList: React.FC<{
  getTopTeamList: () => (LeaderboardTeam | LeaderboardMiniTeam)[];
  event: JamEventDetails | undefined;
  showTeamDetails: (selectedTeamName: string | null) => void;
}> = memo(({ getTopTeamList, event, showTeamDetails }) => {
  const { t } = useTranslation();
  return (
    <Box>
      {getTopTeamList().map(({ teamName, teamDisplayName, rank, score }) => {
        const myTeam = teamName === event?.teamId;
        return (
          <Grid key={teamName} gridDefinition={[{ colspan: 2 }, { colspan: 8 }]}>
            <div className="my-team">
              {!!myTeam && (
                <>
                  <Box variant="h4" margin={{ right: 'xs' }}>
                    {t(i18nKeys.jamDashboard.leaderboard.myTeam)}
                  </Box>
                  <Icon name="caret-right-filled" size="small" />
                </>
              )}
            </div>
            <div className={`row ${myTeam ? 'selected' : ''}`}>
              <div className="box rank">
                <Box variant="h2">{rank}</Box>
              </div>
              <div className="box team-name flexed">
                <Link onFollow={() => showTeamDetails(teamName)}>
                  <Box variant="h2" color="text-status-info">
                    {teamDisplayName}
                  </Box>
                </Link>
              </div>
              <div className="box points">
                <Box variant="h2">{score > 0 ? score : 0} pts</Box>
              </div>
            </div>
          </Grid>
        );
      })}
    </Box>
  );
});

export default BriefTeamList;